import React from "react";
import "./Book_A_Ride.css";

const Book_A_Ride = () => {
  const steps = [
    {
      step: "STEP 1",
      title: "Enter Your Destination",
    },
    {
      step: "STEP 2",
      title: "Confirm Pick-up",
    },
    {
      step: "STEP 3",
      title: "Easy to make Payment",
    },
    {
      step: "STEP 4",
      title: "Receive Booking Confirmation",
    },
    {
      step: "STEP 5",
      title: "Easy Pickup Modification",
      small: "(if needed)",
    },
    {
      step: "STEP 6",
      title: "Enjoy your journey",
    },
  ];
  return (
    <section className="Book_A_Ride">
      <div className="container">
        <div className="Book_A_Ride_header">
          <p className="book_title">How it Works?</p>
          <h5 className="book_subtitle">
            Book a Ride in Simple Steps and Enjoy the Journey
          </h5>
        </div>

        <div className="How_It_Works_row">
          <div className="row">
            {steps.map((item, index) => (
              <div className="col-lg-2 col-md-3 col-sm-4  col-6   mb-4">
                <div className="step_card">
                  <h6 className="step_number">{item.step}</h6>

                  <div className="step_content">
                    <p className="item_title"> {item.title}</p>
                    <p className="item_small"> {item.small}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Book_A_Ride;
